export default "__VITE_ASSET__BZb7Rurx__"